import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Button,
  Table,
  Modal,
  Breadcrumb,
  Card
} from "../UI";
import {
  PlusCircle,
  Trash2,
  ArrowLeftRight,
  AlertTriangle,
} from "lucide-react";
import {
  getDelegateByAdmin,
  removeDelegateAdmin,
  setCurrentDelegate,
} from "../../store/actions";

const DelegationListByAdmin = ({
  getDelegateByAdmin,
  removeDelegateAdmin,
  setCurrentDelegate,
  delegations
}: any) => {

  useEffect(() => {
    getDelegateByAdmin();
  }, []);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [delegateToDelete, setDelegateToDelete] = useState<any>(null);

  const handleDeleteClick = (record: any) => {
    setDelegateToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = () => {
    if (delegateToDelete) {
      removeDelegateAdmin(delegateToDelete.id);
    }
    setIsDeleteModalOpen(false);
    setDelegateToDelete(null);
  };

  const columns = [
    {
      title: "Delegated By",
      key: "delegatedBy",
      render: (delegatedBy: any) => (
        <div className="flex flex-col">
          <span className="font-normal text-slate-700">{delegatedBy?.fullName}</span>
          <span className="text-[10px] text-slate-400 font-mono">{delegatedBy?.oracleId}</span>
        </div>
      )
    },
    {
      title: "Delegated To",
      key: "delegatedTo",
      render: (delegatedTo: any) => (
        <div className="flex flex-col">
          <span className="font-medium text-slate-700">{delegatedTo?.fullName}</span>
          <span className="text-[10px] text-slate-400 font-mono">{delegatedTo?.oracleId}</span>
        </div>
      )
    },
    {
      title: "Action",
      key: "operation",
      render: (_: any, record: any) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteClick(record);
          }}
          className="p-2 text-rose-500 hover:bg-rose-50 rounded-lg transition-colors group"
          title="Remove Delegation"
        >
          <Trash2 className="w-3.5 h-3.5 group-hover:scale-110 transition-transform" />
        </button>
      ),
    },
  ];

  return (
    <div className="space-y-4 animate-in fade-in duration-500">
      <div className="flex flex-col gap-2">
        <Breadcrumb
          items={[
            { label: 'Home', to: '/dashboard' },
            { label: 'Delegation' }
          ]}
        />

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-[#8dc63f]/15 rounded-xl flex items-center justify-center">
              <ArrowLeftRight className="w-4 h-4 text-[#8dc63f]" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 tracking-tight leading-none">Delegations</h1>
          </div>

          <Link to="/adddelegationadmin" className="w-full sm:w-auto">
            <Button className="w-full h-10 px-3 gap-1.5 text-xs font-semibold bg-[#8dc63f] hover:bg-[#76ab32] shadow-sm">
              <PlusCircle className="w-3.5 h-3.5" />
              Add Delegation
            </Button>
          </Link>
        </div>
      </div>

      <Card className="p-0 border-none shadow-xl shadow-slate-200/50 overflow-hidden">
        <Table
          dataSource={delegations || []}
          columns={columns}
          rowKey="_id"
          onRowClick={(record) => setCurrentDelegate(record)}
        />
      </Card>

      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title="Confirm Deletion"
        footer={
          <div className="flex justify-end gap-3 w-full">
            <Button variant="outline" className="border-rose-200 text-rose-600 hover:bg-rose-50" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
            <Button variant="danger" onClick={confirmDelete}>Delete Delegation</Button>
          </div>
        }
      >
        <div className="flex flex-col items-center gap-4 py-4 text-center">
          <div className="w-16 h-16 bg-rose-50 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-rose-500" />
          </div>
          <div className="space-y-2">
            <h3 className="text-lg font-bold text-slate-900">Remove Delegation?</h3>
            <p className="text-sm text-slate-500 max-w-xs">
              This will permanently delete the delegation record. The delegated user will no longer have access to the original user's requests.
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  delegations: state.delegationByAdmin.delegateByAdminData,
  delegate: state.delegation.delegate
});

const mapDispatchToProps = {
  getDelegateByAdmin,
  removeDelegateAdmin,
  setCurrentDelegate
};

export default connect(mapStateToProps, mapDispatchToProps)(DelegationListByAdmin);



